/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const BranchesAndState = styled.div({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  columnGap: token('space.050'),
});

const originalTagMaxWidth = '180';

export const BranchLabel = styled.span({
  background: token('color.background.input'),
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
  borderRadius: token('border.radius', '3px'),
  color: token('color.text.subtle'),
  cursor: 'default',
  display: 'inline-block',
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.medium'),
  maxWidth: `${originalTagMaxWidth}px`,
  overflow: 'hidden',
  paddingBlock: token('space.025'),
  paddingInline: token('space.100'),
  textOverflow: 'ellipsis',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
});

export const ItemWrapper = styled.div({
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: 'normal',
});
